import React from 'react';
import {observer} from 'mobx-react';
import {ComponentServicesPick} from "../../services/component-services-pick";
import {useServices} from "../../react-hooks/use-services.hook";
import {withServices} from "../../react-hooks/with-services";

interface BreadcrumbsComponentProps extends ComponentServicesPick<'siteMap' | 'cmsPages'>{
  
}

const ComponentBody: React.FC<BreadcrumbsComponentProps> = observer((props) => {
  const services = useServices();
  if(!services.configuration.data.generalSettings.showBreadcrumbs
      ||  services.device.hybrid.isEmbedded
      || services.location.isHomePage
      || props.cmsPages.currentPage) {
    return null;
  }

  return (
      <div className={'app-breadcrumbs'}>
        <div className={'breadcrumbs-container'}>
          <div className={'breadcrumbs-links'} itemScope={true} itemType={'http://schema.org/BreadcrumbList'}>
            {props.siteMap.breadcrumbs.map((bcrumb, index) => bcrumb.render(index + 1))}
          </div>
        </div>
      </div>
  );
});

export const BreadcrumbsComponent = withServices(ComponentBody, ['siteMap', 'cmsPages']);
